export default __webpack_public_path__ + "static/media/logo.38e21ce4.png";